<template>
    <ListPage ref="listPage" :query="query" :total="total" v-loading="loading" :data="tableData"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery"
        @selection-change="handleSelectionChange">
        <template slot="filters">
            <el-form-item label="" prop="search_keyword">
                <el-input v-model="query.search_keyword" placeholder="输入ID进行检索" clearable
                    @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="访问日期" prop="date">
                <el-date-picker v-model="query.date" type="daterange" align="left" unlink-panels range-separator="-"
                    value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('yhgl_yhlb_pldc')">
            <el-button size="mini" type="primary" @click="handleExport"> 批量导出 </el-button>
        </template>
        <template slot="columns">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column label="cookie ID" align="center" prop="uuid" show-overflow-tooltip />
            <el-table-column label="IP地址" align="center" prop="ip" />
            <el-table-column label="浏览器类型" align="center" prop="browser_type" />
            <el-table-column label="操作系统" align="center" prop="os" />
            <el-table-column label="最后访问时间" align="center" prop="last_login_time" />
            <el-table-column v-if="permission('yhgl_yhlb_ckxq')" label="操作" align="center" width="100">
                <template slot-scope="{ row }">
                    <el-button size="mini" type="text" @click="handleDetail(row)"> 查看详情 </el-button>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { list } from "@/api/user/list";
import { startDate, endDate } from "@/pages/config";
import listMixin from "@/mixins/list";
import { downloadFileByUrl } from "@/jslibs/utils";

export default {
    data() {
        return {
            list,
            // 查询参数
            query: {
                search_keyword: "",
                date: [],
            },
            detailPath: "/user/detail",
            pick: true,
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            const params = {
                ...this.query,
                search_start_time: this.query.date && this.query.date[0] ? startDate(0, this.query.date[0]) : null,
                search_end_time: this.query.date && this.query.date[1] ? endDate(0, this.query.date[1]) : null,
            };
            delete params.date;
            this._search(params);
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        async handleExport() {
            const filename = "cookie用户列表.xlsx";
            const { search_keyword } = this.query;
            const [search_start_time, search_end_time] = this.query.date;
            const uuids = this.picks.map(x => x.uuid).join();
            downloadFileByUrl(
                process.env.VUE_APP_BASE_URL +
                `/v1/cms/cookie_user?export=1&search_keyword=${search_keyword}&search_start_time=${search_start_time || ''}&search_end_time=${search_end_time || ''}&uuids=${uuids}`,
                filename
            );
        },
    },
};
</script>
